import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTimes, FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import './style.css';

const LevelTestModal = ({ isOpen, onClose, existingResult }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        // Prevent closing by clicking backdrop
        e.stopPropagation();
    };

    const handleViewResults = () => {
        navigate('/level-test/results', {
            state: {
                testResults: existingResult,
                fromTest: false
            }
        });
    };

    const handleGoToDashboard = () => {
        navigate('/dashboard');
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Unknown date';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        } catch (error) {
            return 'Unknown date';
        }
    };

    return (
        <div className="level-test-modal-overlay" onClick={handleBackdropClick}>
            <div className="level-test-modal-container">
                <div className="level-test-modal-header">
                    <div className="level-test-modal-icon">
                        <FaCheckCircle />
                    </div>
                </div>
                
                <div className="level-test-modal-content">
                    <h2 className="level-test-modal-title">Assessment Already Completed</h2>
                    <p className="level-test-modal-message">
                        You have already completed the Arabic level assessment. Each user can take the assessment once to ensure accurate placement.
                    </p>
                    
                    {existingResult && (
                        <div className="existing-result-summary">
                            <div className="result-item">
                                <span className="result-label">Your Level:</span>
                                <span className="result-value level-badge">{existingResult.level_result || existingResult.level || 'N/A'}</span>
                            </div>
                            <div className="result-item">
                                <span className="result-label">Score:</span>
                                <span className="result-value">{existingResult.score || 0}%</span>
                            </div>
                            <div className="result-item">
                                <span className="result-label">Completed:</span>
                                <span className="result-value">{formatDate(existingResult.completed_at || existingResult.test_date || existingResult.created_at)}</span>
                            </div>
                        </div>
                    )}
                    
                    <div className="level-test-modal-actions">
                        <button 
                            className="level-test-modal-btn level-test-modal-btn-primary"
                            onClick={handleGoToDashboard}
                        >
                            Go to Dashboard
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LevelTestModal;
